import { Component } from 'react';

import './circle-member-section.css';
import { getCircleMembers } from '../../../../modules/user_api';

import CircleMemberTable from './circle-member-table';
import CircleMemberForm from './circle-member-form';

class CircleMemberSection extends Component {
  constructor(props) {
    super(props);

    this.MODES = {
      ADD: 1,
      EDIT: 2,
    };

    this.state = {
      show_circle_member_form: false,
      circle_members: false,
      form_mode: this.MODES.ADD,
      editted_circle_member: false,
      circle_member_changed: false,
    };
  }

  async componentDidMount() {
    const { player } = this.props;
    const circleMembersResponse = await getCircleMembers(player.id);

    if (circleMembersResponse.data.success) {
      const circleMembers = circleMembersResponse.data.circle_members;
      this.setState({ circle_members: circleMembers });
    }
  }

  circleMemberAdded(circleMember) {
    const { circle_members } = this.state;
    let circleMembersArray;
    if (!circle_members) {
      circleMembersArray = [];
    } else {
      circleMembersArray = circle_members;
    }

    circleMembersArray.push(circleMember);

    this.setState({ show_circle_member_form: false });
  }

  startCircleMemberEdit(circleMember) {
    this.setState({
      show_circle_member_form: true,
      form_mode: this.MODES.EDIT,
      editted_circle_member: circleMember,
      circle_member_changed: true,
    });
  }

  showCircleMemberForm() {
    this.setState({ show_circle_member_form: true, form_mode: this.MODES.ADD, editted_circle_member: false });
  }

  hideCircleMemberForm() {
    this.setState({ show_circle_member_form: false });
  }

  cancelCircleMemberChanged() {
    this.setState({ circle_member_changed: false });
  }

  render() {
    const { player, home_user } = this.props;
    const { circle_members, show_circle_member_form, form_mode, editted_circle_member, circle_member_changed } =
      this.state;

    return (
      <div className="circle_members_section">
        <CircleMemberTable
          circle_members={circle_members}
          player={player}
          home_user={home_user}
          start_circle_member_edit={this.startCircleMemberEdit.bind(this)}
        />
        <CircleMemberForm
          player={player}
          show={show_circle_member_form}
          hide_func={this.hideCircleMemberForm.bind(this)}
          circle_member_added={this.circleMemberAdded.bind(this)}
          mode={form_mode}
          circle_member={editted_circle_member}
          circle_member_changed={circle_member_changed}
          cancel_circle_member_changed={this.cancelCircleMemberChanged.bind(this)}
        />
        <button className="add_circle_member_button" onClick={this.showCircleMemberForm.bind(this)}>
          Add Circle Member
        </button>
      </div>
    );
  }
}

export default CircleMemberSection;
